import {init, getFeatureFlag} from '@simpleinvest/front-end-remote-config';

const client = init({
  sdkKey: process.env.VUE_APP_CONFIGCAT_CLIENT_PLATFORM_SDK_KEY as string,
});

export const wealthProjectionNoCanHazMoment = (): Promise<boolean> =>
  getFeatureFlag(client, 'WEALTH_PROJECTION_NO_CAN_HAZ_MOMENT', false);

export const showYearToDateTransactionsSummary = (): Promise<boolean> =>
  getFeatureFlag(client, 'CAN_HAZ_PRETTY_MONIES_SUMMARY', false);

export const secAccountOpeningForm = (): Promise<boolean> => getFeatureFlag(client, 'SEC_ACCOUNT_OPENING_FORM', false);

export const w4rFedaralTaxFlag = (): Promise<boolean> => getFeatureFlag(client, 'FF_W4R_FEDERAL_TAX', false);

export const rbpNewFlag = (): Promise<boolean> => getFeatureFlag(client, 'RBP_NEW', false);

export const ga4PocFlag = (): Promise<boolean> => getFeatureFlag(client, 'GA4_POC', false);

export const plaidLinkStatus = (): Promise<boolean> => getFeatureFlag(client, 'PLAID_LINK_STATUS', false);

export const clientCDODemo = (): Promise<boolean> => getFeatureFlag(client, 'CLIENT_CDO_DEMO', false);

export const changesPostADO = (): Promise<boolean> => getFeatureFlag(client, 'POST_ADO_CHANGES', false);

export const increaseACHLimit = (): Promise<boolean> => getFeatureFlag(client, 'ACH_LIMIT', false);

export const stateTaxWithholding = (): Promise<boolean> => getFeatureFlag(client, 'STATE_TAX_WITHHOLDING', false);

export const stateTaxWithholdingLiquidation = (): Promise<boolean> =>
  getFeatureFlag(client, 'STATE_TAX_WITHHOLDING_LIQUIDATION', false);

export const onboardingGoingLiveBeforeServicing = (): Promise<boolean> =>
  getFeatureFlag(client, 'ONBOARDING_BEFORE_SERVICING', false);

export const restrictAccessToLegacyApp = (): Promise<boolean> => getFeatureFlag(client, 'LEGACY_UI_ACCESS', false);
